import classNames from 'classnames';
import { useCallback } from 'react';
import { Heading } from 'yoso';
import { BaseCard } from '~/components/Card';
import {
  useHomeProcedureScoreUpSuccessHandler,
  useProceedScoreUp,
} from '~/components/Challenge/Score/ChallengeScore.hooks';
import { T } from '~/components/I18n';
import gem from '~/components/Icon/gem.png';
import { Chevron } from '~/components/Icon/v2/Chevron';
import styles from './ChallengeScoreUpCta.module.scss';

export type ChallengeScoreUpCtaProps = {
  className?: string;
};

export const ChallengeScoreUpCta = ({ className }: ChallengeScoreUpCtaProps) => {
  const { mutateAsync } = useProceedScoreUp({
    onSuccess: useHomeProcedureScoreUpSuccessHandler(),
  });
  const onClick = useCallback(() => {
    mutateAsync();
  }, [mutateAsync]);

  return (
    <BaseCard
      className={classNames(styles.root, className)}
      size="large"
      shadow
      onClick={onClick}
      data-event="click"
      data-event-target="score_up_ranking_btn_in_home">
      <img src={gem} alt="score up" width={22} height={22} className={styles.image} />
      <Heading level={4} className={styles.title}>
        <T name="citizen_home_scoreup_banner1" /> <Chevron className={styles.chevron} />
      </Heading>
    </BaseCard>
  );
};
